<template>
  <div>
    <CompanyDeposit v-if="isOffice" />
    <SupperDealerDeposit v-if="isSupperDealer" />
  </div>
</template>

<script>
import CompanyDeposit from './company/index'
import SupperDealerDeposit from './supper-dealer/index'
export default {
  name: 'deposit',
  components: {
    CompanyDeposit,
    SupperDealerDeposit
  },
  data() {
    return {}
  },
  computed: {
    isOffice() {
      return this.$store.state.authUser
        ? this.$store.state.authUser.user_type == 1
        : false
    },
    isSupperDealer() {
      if (this.$store.state.authUser) {
        return (
          this.$store.state.authUser.user_type == 2 ||
          this.$store.state.authUser.user_type == 3
        )
      }
      return false
    }
  }
}
</script>
